import { apiFetch } from "./client";
import type { AdminSession } from "../auth/TokenContext";

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  user: AdminSession["user"];
}

export function adminLogin(email: string, password: string) {
  return apiFetch<LoginResponse>("/admin/auth/login", {
    method: "POST",
    body: { email, password },
    skipAuth: true,
  });
}

export function adminMe() {
  return apiFetch<AdminSession["user"]>("/admin/auth/me");
}
